import { FaTimes } from "react-icons/fa";
export interface BaseModalProps {
  visible?: boolean;
  onClose?: () => void;
  children?: JSX.Element;
  title?: string;
  hideCloseBtn?: boolean;
  onSuccess?: () => void;
  width?: number;
}

export const BaseModal = (props: BaseModalProps) => {
  const handleBackgroundClick = (e: React.MouseEvent<HTMLDialogElement>) => {
    e.stopPropagation();
    props.onClose?.();
  };

  const handleContentClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <dialog
      className="modal"
      open={props.visible}
      onClick={handleBackgroundClick}>
      <div
        className="relative w-full pt-10 rounded modal-box"
        onClick={handleContentClick}
        style={{ maxWidth: props.width }}>
        {props.title ? (
          <div className="flex flex-row items-center justify-between mb-5">
            {props.title ? (
              <h2 className="mb-4 text-lg lg:text-xl font-700">
                {props.title}
              </h2>
            ) : null}
          </div>
        ) : null}

        {!props.hideCloseBtn ? (
          <button
            onClick={props.onClose}
            className="absolute top-0 right-0 flex items-center justify-center w-10 h-10 text-xl button">
            <FaTimes />
          </button>
        ) : null}

        {props.children}
      </div>
    </dialog>
  );
};
